import _extends from 'babel-runtime/helpers/extends';
import _Promise from 'babel-runtime/core-js/promise';

import WkUploadCell from './WkUploadCell';

export default {
  // 文件上传
  name: 'FileUpload',
  components: {
    WkUploadCell: WkUploadCell
  },
  props: {},
  data: function data() {
    return {
      visible: false,
      isUnfold: true,
      uploadList: []
    };
  },

  computed: {
    unfoldIcon: function unfoldIcon() {
      return this.isUnfold ? 'el-icon-minus' : 'el-icon-plus';
    }
  },
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    /**
     * data 必须包含  file
     * 可选 request  params
     * data 辅助信息
     */
    upload: function upload(data) {
      var _this = this;

      this.visible = true;
      return new _Promise(function (resolve, reject) {
        // eslint-disable-line
        _this.uploadList.push(_extends({}, data, {
          complete: false,
          resolve: resolve,
          reject: reject
        }));
      });
    },
    close: function close() {
      var _this2 = this;

      var allComplete = true;
      for (var index = 0; index < this.uploadList.length; index++) {
        var element = this.uploadList[index];
        if (!element.complete) {
          allComplete = false;
          break;
        }
      }

      if (allComplete) {
        this.uploadList = [];
        this.visible = false;
      } else {
        this.$confirm('关闭窗口，将取消上传任务，是否继续?', '提示', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          for (var _index = 0; _index < _this2.uploadList.length; _index++) {
            var _element = _this2.uploadList[_index];
            if (_element.cancelToken) {
              _element.cancelToken();
            }
          }

          _this2.uploadList = [];
          _this2.visible = false;
        }).catch(function () {
          _this2.isUnfold = false;
        });
      }
    },
    unfoldClick: function unfoldClick() {
      this.isUnfold = !this.isUnfold;
    },


    /**
     * 上传完成
     */
    uploadCompleted: function uploadCompleted(index, res) {
      var data = this.uploadList[index];
      data.res = res;
      data.complete = true;
      if (data.resolve) {
        data.resolve(data);
      }
    },
    uploadDelete: function uploadDelete(index) {
      this.uploadList.splice(index, 1);
    },
    cancelTokenChange: function cancelTokenChange(cancelToken, index) {
      var data = this.uploadList[index];
      this.$set(data, 'cancelToken', cancelToken);
    }
  }
};